export const CURRENT_BOT = 'https://ecochatbots.s3.eu-central-1.amazonaws.com/bots/index.html'
export const NEW_BOT = 'https://ecochatbots.s3.eu-central-1.amazonaws.com/bots/index.html'